import React, { useState } from "react"
import Loading from "@/components/common/Loading"
import RequestSnackbar from "@/components/common/RequestSnackbar"

const useFullPageLoader = ({ content, requestSuccessStatus, responseMessage, snackbarOpen, handleSnackbarOpenStatus }) => {
    const [loading, setLoading] = useState(false)
    return [
        loading ? (
            <Loading content={content} />
        ) : (
            <RequestSnackbar
                status={requestSuccessStatus}
                message={responseMessage}
                snackbarOpen={snackbarOpen}
                handleSnackbarOpenStatus={handleSnackbarOpenStatus}
            />
        ),
        () => setLoading(true),
        () => setLoading(false),
    ]
}

export default useFullPageLoader
